// Confirmation modal: prompts user to save or discard unsaved form edits before switching rows
import './UnsavedChangesModalContent.css';

import ModalBody from '../ControlActionModalContent/components/ModalBody/ModalBody';
import { useTranslate } from '../../../hooks/context/useTranslate';
import { useModalKeyboard } from '../../../hooks/shortcuts/useModalKeyboard';
import Button from '../../Button/Button';

export interface UnsavedChangesModalProps {
  onSave: () => void;
  onDiscard?: () => void;
  onCancel?: () => void;
}

const UnsavedChangesModalContent = ({
  onSave,
  onDiscard,
  onCancel,
}: UnsavedChangesModalProps) => {
  const { t } = useTranslate();

  useModalKeyboard({ onEnter: onSave });

  return (
    <ModalBody
      header={t('warning')}
      text={t('unsavedChangesText')}
      className="unsaved-changes-modal"
      buttons={
        <>
          <Button color="primary" onClick={onSave}>
            {t('save')}
          </Button>
          {onDiscard && (
            <Button color="light" fill="solid" onClick={onDiscard}>
              {t(onCancel ? 'discardChanges' : 'cancel')}
            </Button>
          )}
          {onCancel && (
            <Button color="light" fill="solid" onClick={onCancel}>
              {t('cancel')}
            </Button>
          )}
        </>
      }
    />
  );
};

export default UnsavedChangesModalContent;
